import {
  getallscrutinynotesError,
  getallscrutinynotesSuccess,
  getallscrutinynotestypeError,
  updateScrutinyStatusError,
  updateScrutinyStatusSuccess,
  getallscrutinynotestypeSuccess,
  togglePageLoader,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
// import toast from "toastr"
// Login Redux States
import {
  get_ScrutinyNotes,
  get_ScrutinyNotesType,
  update_scrutinystatus
} from "helpers/backend_helper"
import { GET_ALL_SCRUTINY_NOTES, GET_ALL_SCRUTINY_NOTES_TYPE, UPDATE_SCRUTINY_STATUS } from "./actionType"

function* getScrutinyNotesList({ payload: notes }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_ScrutinyNotes, notes)
    if (response.status === "Success") {
      yield put(getallscrutinynotesSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(getallscrutinynotesError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getallscrutinynotesError(error))
    yield put(togglePageLoader(false))
  }
}

function* getScrutinyNotesTypesList() {
  try {
    const response = yield call(get_ScrutinyNotesType)
    if (response.status === "Success") {
      yield put(getallscrutinynotestypeSuccess(response))
    } else {
      yield put(getallscrutinynotestypeError(response))
    }
  } catch (error) {
    yield put(getallscrutinynotestypeError(error))
  }
}

function* updateScrutinyStatus({ payload: data }) {
    try {
      yield put(togglePageLoader(true))
      const response = yield call(update_scrutinystatus, data)
      if (response.status === "Success") {
        yield put(updateScrutinyStatusSuccess(response))
        // toast.success(response.message)
        yield put(togglePageLoader(false))
      } else {
        yield put(updateScrutinyStatusError(response))
        // toast.error(response)
        yield put(togglePageLoader(false))
      }
    } catch (error) {
      yield put(updateScrutinyStatusError(error))
      // toast.error(error?.response ? error.response?.data?.message : error)
      yield put(togglePageLoader(false))
    }
}

function* scrutinynotesage() {
  yield takeEvery(GET_ALL_SCRUTINY_NOTES, getScrutinyNotesList)
  yield takeEvery(GET_ALL_SCRUTINY_NOTES_TYPE, getScrutinyNotesTypesList)
  yield takeEvery(UPDATE_SCRUTINY_STATUS, updateScrutinyStatus)
}

export default scrutinynotesage
